<template>
	<div class="small-12 flex justify-center page articles animated fadeIn" v-if="loaded">
		<header-public/>
		<div class="small-12 pageContentWrap flex justify-center">
			<div class="small-12 pageContent">
				<div class="small-12 flex justify-center blogArticle">
                    <blog-nav/>
					<div class="small-12 large-8 columns articleDetails" v-if="article">
						<article-title :article="article"/>
                        <article-share :article="article"/>
                        <article-feature-image :article="article" v-if="article.links.feature_image"/>
						<article-content :article="article"/>
                        <do-you-like/>
                        <disclaimer/>
					</div>
                    <div class="small-12 large-2">
                        <trending-stories/>
                    </div>
                    <recommended-stories/>
				</div>
			</div>
			<public-footer/>
		</div>
	</div>
	<loading-spinner :loaded="loaded" v-else/>
</template>

<script>

	// Import the mixins
    import { GetArticle } from '@/events/articles/GetArticle'

	// Import the components
	import LoadingSpinner from '@/components/framework/helpers/LoadingSpinner.vue'
	import PublicFooter from '@/components/framework/footer/PublicFooter.vue'
    import HeaderPublic from '@/components/framework/header/HeaderPublic.vue'
    import BlogNav from '@/components/blog/shared/BlogNav.vue'
    import ArticleTitle from '@/components/blog/article/ArticleTitle.vue'
    import ArticleShare from '@/components/blog/article/ArticleShare.vue'
	import ArticleFeatureImage from '@/components/blog/article/ArticleFeatureImage.vue'
	import ArticleContent from '@/components/blog/article/ArticleContent.vue'
    import TrendingStories from '@/components/blog/article/TrendingStories.vue'
    import DoYouLike from '@/components/blog/article/DoYouLike.vue'
    import Disclaimer from '@/components/blog/article/Disclaimer.vue'
    import RecommendedStories from '@/components/blog/article/RecommendedStories.vue'

	export default {

		/*
		** Set the component name
		*/

		name: 'Index',

		/*
		**  Register the components
		*/

		components: {

			LoadingSpinner,
            HeaderPublic,
			ArticleTitle,
            ArticleShare,
			ArticleFeatureImage,
			ArticleContent,
			PublicFooter,
            BlogNav,
            TrendingStories,
            DoYouLike,
            Disclaimer,
            RecommendedStories

		},

		/*
		**  Register the mixins
		*/

		mixins: [

            GetArticle

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			loaded: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
		**  Do this first
		*/

		created() {

			/*
            **  Get the article
            **  @location: @here
            */

            this.getArticle();

		},

		/*
		**  Set up the methods
		*/

		methods: {

			getArticle: function() {

                /*
                **  Get the article
                **  @location: Events/Articles/GetArticle
                */

				this.getArticleHandler()
                .then(() => {

                    /*
                    **  Set the loaded prop
                    **  @prop_location: @here
                    */

                    this.loaded = true;

                });

			}

		}

	}

</script>